import React, { useRef, useMemo } from 'react';
import * as echarts from 'echarts';
import * as turf from '@turf/turf';
import ReactEcharts from 'echarts-for-react';
import {
  setColorScheme,
  storeErrorDetails,
} from '../../../redux/ChartPoperties/ChartControlsActions';
import { changeGeoMapUnMatched } from '../../../redux/ChartPoperties/ChartControlsActions';
import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { ChartControlsProps } from '../../../redux/ChartPoperties/ChartControlsInterface';

import { ChartsMapStateToProps, ChartsReduxStateProps } from '../ChartsCommonInterfaces';

import {
  interpolateColor,
  fieldName,
  displayName,
  checkUidPresenceInCheckedMeasureForTooltip,
  applyOpacityToColor,
} from '../../CommonFunctions/CommonFunctions';
import { FetchGeoJSON, getGeoJSON } from './GeoJSON/MapCommonFunctions';
import { updateGeoChartStyleOptions } from '../../../redux/ChartPoperties/ChartControlsActions';
import { UserFilterCardProps } from '../../ChartFieldFilter/UserFilterCardInterface';
import { getChartData } from '../../ChartAxes/chartDataFunctions/getChartDataFunction';
import FetchData from '../../ServerCall/FetchData';
import { AxesValuProps } from '../../ChartAxes/ChartAxesInterfaces';
import { Dispatch } from 'redux';
import { fontSize, palette } from '../../..';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux';

import { updateHoveredItems } from '../../../redux/TabTile/TabActions';
import { tooltipStyle } from '../../Common/EChartTooltip';
import useCombinedColorSchemes from '../../../hooks/useCombinedColorSchemes';
import { aspectScaleMap, geoCenters } from './Components/MapCommonComponents';
import LoadingPopover from '../../CommonFunctions/PopOverComponents/LoadingPopover';
import { getGeoJSONDB } from './GeoJSON/GeoJSONDatabase';
import { formatNumberWithAbbrev } from '../../ChartOptions/Format/NumberFormatter';
import { LABEL_THRESHOLDS, LEGEND_THRESHOLDS } from '../../ChartOptions/ChartThresholds';

export var bgColors: { [key: string]: string } = {};

const BubbleMap = ({
  //props
  propKey,
  graphDimension,
  graphTileSize,
  colorScheme,
  fontFamily,

  chartGroup,
  chartArea,
  dashBoardGroup,
  token,
  setMapJSON = () => {},
  setLoading = () => {},

  // unMatched,

  //state
  chartControls,
  chartProperties,
}: ChartsReduxStateProps & UserFilterCardProps & any) => {
  const {
    tabTileProps,
    tooltipFormats,
    chartAxes,
    isTooltipEnabled,
    savedCalculations,
    stateCheckBox,
    tabState,
    selectedTab,
  } = useSelector((state: RootState) => ({
    tabTileProps: state.tabTileProps,
    tooltipFormats: state.chartControls?.properties[propKey]?.formatOptions?.tooltipFormats,
    chartAxes: state.chartProperties.properties[propKey]?.chartAxes,
    isTooltipEnabled:
      state.chartControls?.properties[propKey]?.formatOptions?.tooltipFormats?.isEnable,
    savedCalculations: state.calculations.savedCalculations,
    stateCheckBox: state.chartControls?.properties[propKey]?.labelOptions?.stateCheckBox,
    tabState: state.tabState,
    selectedTab: state.tabTileProps.selectedTabId,
  }));

  let geoLocation = chartProperties.properties[propKey].Geo.geoLocation;

  var type = chartProperties.properties[propKey].Geo.geoMapKey;
  var chartControl: ChartControlsProps = chartControls.properties[propKey];

  // var geoStyle: ChartConGeoChartControls = chartControls.properties[propKey].geoChartControls || {};

  let chartData: any[] = chartControl.chartData ? chartControl.chartData : [];
  let mapData: any[] = [];
  let _locationField = chartProperties.properties[propKey].chartAxes[2];
  let _dimensionField = chartProperties.properties[propKey].chartAxes[1];
  let _measureField = chartProperties.properties[propKey].chartAxes[3];
  // let keyName = fieldName(_locationField.fields[0]);
  let keyName = displayName(_locationField.fields[0]);
  // let dimName = fieldName(_dimensionField.fields[0]);
  // let dimDispName = displayName(_dimensionField.fields[0]);

  let dimName = _dimensionField.fields?.length ? fieldName(_dimensionField.fields[0]) : '';
  let dimDispName = _dimensionField.fields?.length ? displayName(_dimensionField.fields[0]) : '';
  const prevGeoLocationRef = useRef(geoLocation);
  let valueName = _measureField.fields[0]?.fieldname;
  let valueDispName = displayName(_measureField.fields[0]);
  const mouseOverInteractivity =
    tabState.tabs[selectedTab]?.interactivity?.mouseOverInteractivity || false;

  const [options, setOptions] = useState({});
  const [mapLoading, setMapLoading] = useState<boolean>(false);
  const [mapJSON, setMapGeoJSON] = useState<any>('');
  const activeGeoRef = useRef<string | null>(null);
  const geoStyle = useSelector(
    (state: RootState) => state.chartControls.properties[propKey].geoChartControls,
    (a, b) => JSON.stringify(a) === JSON.stringify(b), // deep comparison
  );

  let index = 0;
  if (!geoStyle.bgCol) {
    geoStyle.bgCol = bgColors;
    updateGeoChartStyleOptions(propKey, 'bgCol', bgColors);
  }

  const allThemes = useCombinedColorSchemes();
  const chartThemes = allThemes.filter((el) => {
    if (!chartControl.colorScheme || (chartArea === 'dashboard' && !geoStyle.manualColor)) {
      return el.name === colorScheme;
    } else {
      return el.name === chartControl.colorScheme;
    }
  });

  const selectedTheme = chartThemes.length > 0 ? chartThemes[0] : allThemes[0];

  const chartRef = useRef<any>(null);
  const prevValueNameRef = useRef<string | undefined>(undefined);
  const selectedRangeRef = useRef<[number, number] | null>(null);
  const dispatch = useDispatch();

  const [chartDataKeys, setChartDataKeys] = useState<string[]>([]);
  const [cityGeoJSON, setCityGeoJSON] = useState<any>(null);

  const showStateLabel: boolean = chartControls.properties[propKey].labelOptions.showStateLabel;

  //====  shared function for bubble map colors

  // Helper to remove alpha channel from 9-char hex colors
  const hexRemoveAlpha = (color: any) => {
    if (typeof color === 'string' && color.startsWith('#') && color.length === 9) {
      return color.slice(0, 7);
    }
    return color;
  };

  // Get gradient configuration based on theme and manual color settings
  const getGradientConfig = () => {
    const rawStartColor =
      geoStyle.manualColor && geoStyle.minColor && geoStyle.minColor !== ''
        ? geoStyle.minColor
        : selectedTheme?.colors?.[1] || '#AF99DB';

    const rawEndColor =
      geoStyle.manualColor && geoStyle.maxColor && geoStyle.maxColor !== ''
        ? geoStyle.maxColor
        : selectedTheme?.colors?.[0] || '#2BB9BB';

    const startColor = hexRemoveAlpha(rawStartColor);
    const endColor = hexRemoveAlpha(rawEndColor);
    const gradientColors = interpolateColor(startColor, endColor, 100);

    return { startColor, endColor, gradientColors };
  };

  // Calculate bubble color based on value, dimension, and gradient settings
  const getBubbleColor = (
    value: number,
    dim: string | undefined,
    dataMin: number,
    dataMax: number,
    gradientColors: string[],
    endColor: string,
  ) => {
    const defaultThemeColor = selectedTheme?.colors?.[0] || '#2bb9bb';
    const hasDimension = chartProperties.properties[propKey].chartAxes[1]?.fields?.length > 0;
    const isDivergent =
      geoStyle.manualColor ||
      chartControls.properties[propKey]?.geoChartControls?.isDivergentModeEnabled;

    let baseColor = defaultThemeColor;

    if (hasDimension && dim && geoStyle.bgCol?.[dim]) {
      // Use dimension-based color
      baseColor = geoStyle.bgCol[dim];
    } else if (isDivergent) {
      // Use gradient interpolation based on value (only when divergent mode is ON)
      let percent = 0;
      if (dataMax > dataMin) {
        percent = (value - dataMin) / (dataMax - dataMin);
      }
      percent = Math.max(0, Math.min(1, percent));
      const colorIndex = Math.floor(percent * 99);
      baseColor = gradientColors[colorIndex] || endColor;
    }
    // When divergent is OFF and no dimension, using defaultThemeColor

    return baseColor;
  };
  //===========
  useEffect(() => {
    if (chartData.length >= 1) {
      if (typeof chartData === 'object' && chartData.length > 0) {
        setChartDataKeys(Object.keys(chartData[0]));
      }
    }
  }, [chartData]);

  useEffect(() => {
    if (prevGeoLocationRef.current !== geoLocation) {
      changeGeoMapUnMatched(propKey, []);
      prevGeoLocationRef.current = geoLocation;
    }
  }, [geoLocation, propKey, changeGeoMapUnMatched]);

  let bubbleSize: any[] = [];

  useEffect(() => {
    const currentGeo = chartProperties.properties[propKey].Geo.geoLocation;

    if (!currentGeo) return;

    activeGeoRef.current = currentGeo;

    const city = chartProperties.properties[propKey].Geo.geoLocation;
    if (!city) return;

    const cityName = city.toLowerCase();
    let trimmed = cityName.replace('cities', '').replace(/\s+/g, '').trim();

    if (trimmed === 'indian') trimmed = 'india';
    if (trimmed === 'usa') trimmed = 'us';

    async function loadCity() {
      const geoForThisCall = currentGeo;
      let mod;

      let dbKey: string;

      if (city === 'World Cities') {
        dbKey = 'world cities';
      } else if (city === 'world') {
        dbKey = 'world';
      } else if (cityName === trimmed) {
        dbKey = trimmed;
      } else {
        if (trimmed === 'india') {
          dbKey = 'indian cities';
        } else if (trimmed === 'us') {
          dbKey = 'usa cities';
        } else {
          dbKey = `${trimmed} cities`;
        }
      }

      // CHECK INDEXED DB
      const cached = await getGeoJSONDB(dbKey);

      if (activeGeoRef.current !== geoForThisCall) return;

      if (cached?.data) {
        setCityGeoJSON(cached.data.cities);
        return;
      }

      // FETCH FROM BACKEND
      if (city === 'World Cities') {
        mod = await FetchGeoJSON('world', 'world', 'city');
      } else if (cityName === trimmed) {
        mod = await FetchGeoJSON(trimmed, 'world', 'country');
      } else {
        mod = await FetchGeoJSON(trimmed, 'country', 'city');
      }

      if (activeGeoRef.current !== geoForThisCall) return;

      setCityGeoJSON(mod);
    }

    loadCity();
  }, [chartProperties.properties[propKey].Geo.geoLocation]);

  const generateScatterData = () => {
    let pointFeatures =
      cityGeoJSON?.features?.filter((f: any) => f.geometry?.type === 'Point') || [];

    function extractLastWord(inputString: string) {
      if (!inputString) return null;
      const parts = inputString.split(' of ');
      return parts[parts.length - 1];
    }

    const processedKeyName = extractLastWord(keyName);
    const finalKeyName = processedKeyName || keyName;

    const normalize = (str: any) =>
      typeof str === 'string'
        ? str
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .trim()
        : '';

    const processedChartData = chartData.map((item) => ({
      originalKey: item[finalKeyName],
      processedKey: item[finalKeyName]?.toString().trim(),
      measureValue: item[valueDispName] || 0,
      dim: chartProperties.properties[propKey].chartAxes[1]?.fields?.[0]?.displayname || '', // slice
      key: item[keyName],
    }));

    const scatterPoints: any[] = [];

    if (chartProperties.properties[propKey].Geo.unMatchedChartData?.length > 0) {
      chartProperties.properties[propKey].Geo.unMatchedChartData.forEach((item: any) => {
        if (item.selectedKey !== '') {
          processedChartData.forEach((dataItem) => {
            if (normalize(dataItem.originalKey) === normalize(item[keyName])) {
              const name = item.selectedKey.includes(';')
                ? item.selectedKey.split(';')[1]?.trim()
                : item.selectedKey;
              dataItem.processedKey = name;
            }
          });
        }
      });
    }

    // Use shared gradient configuration
    const { endColor, gradientColors } = getGradientConfig();

    // Get min/max for gradient calculation
    const allValues = processedChartData.map((d) => d.measureValue);
    const dataMin = Math.min(...allValues);
    const dataMax = Math.max(...allValues);

    processedChartData.forEach((dataItem) => {
      const { processedKey, measureValue, dim, key } = dataItem;

      const firstFeatureProps = pointFeatures[0]?.properties || {};
      const availableKeys = Object.keys(firstFeatureProps);
      const effectiveKey = availableKeys.includes('city')
        ? 'city'
        : availableKeys.includes(type)
          ? type
          : availableKeys.includes('name')
            ? 'name'
            : type;

      const feature = pointFeatures.find((f: any) => {
        const props = f.properties || {};
        const featureKey = props[effectiveKey];
        return normalize(featureKey) === normalize(processedKey);
      });

      if (feature) {
        const coords = feature.geometry.coordinates;

        // Use shared helper for bubble color calculation
        const baseColor = getBubbleColor(
          measureValue,
          dim,
          dataMin,
          dataMax,
          gradientColors,
          endColor,
        );

        // Apply opacity to the color
        const fillOpacity = (geoStyle.opacity ?? 70) / 100;
        const fillColor = applyOpacityToColor(baseColor, fillOpacity);

        scatterPoints.push({
          name: processedKey,
          size: measureValue,
          value: [coords[0], coords[1], measureValue],
          originalKey: key,
          itemStyle: {
            color: fillColor,
            borderColor: geoStyle.enableBubbleBorder ? baseColor : undefined,
            borderWidth: geoStyle.enableBubbleBorder ? geoStyle.bubbleBorderWidth : 0,
            opacity: 1,
          },
        });
      }
    });

    return scatterPoints;
  };

  // useEffect(() => {
  //   dispatch(updateLabelOption(propKey, 'showLabel', false));
  // }, []);

  const chartErrorDetails = (propKey: string, error: any) => {
    dispatch(storeErrorDetails(propKey, error));
  };

  const formatMinMaxValue = (
    value: number,
    separator: 'None' | 'Comma' | 'Abbrev',
    formatType: 'Number' | 'Currency' | 'Percent' = 'Number',
    enableRounding: boolean,
    roundingDigits: number,
  ) => {
    const currencySymbol = geoStyle.currencySymbol ?? '$';
    const percentType = geoStyle.percentType ?? 'NonCalculated';

    if (isNaN(value)) return value.toString();

    const safeRoundingDigits = Math.min(Math.max(roundingDigits, 0), 4);

    const workingValue =
      formatType === 'Percent' && percentType === 'Calculated' ? value * 100 : value;

    const roundedValue = !enableRounding
      ? Math.round(workingValue)
      : Number(workingValue.toFixed(safeRoundingDigits));

    let formatted: string;

    switch (separator) {
      case 'Comma':
        formatted = roundedValue.toLocaleString(undefined, {
          minimumFractionDigits: enableRounding ? 0 : safeRoundingDigits,
          maximumFractionDigits: enableRounding ? 0 : safeRoundingDigits,
        });
        break;

      case 'Abbrev':
        formatted = formatNumberWithAbbrev(roundedValue, enableRounding ? 0 : safeRoundingDigits);
        break;

      case 'None':
      default:
        formatted = enableRounding
          ? roundedValue.toString()
          : roundedValue.toFixed(safeRoundingDigits);
    }

    switch (formatType) {
      case 'Percent':
        return `${formatted} %`;

      case 'Currency':
        return `${currencySymbol} ${formatted}`;

      default:
        return formatted;
    }
  };

  const generatePieSeriesForCities = () => {
    let features = cityGeoJSON?.features || mapJSON?.features || [];
    const pointFeatures = features.filter((f: any) => f.geometry?.type === 'Point');

    const grouped: Record<string, any[]> = {};

    const normalize = (str: any) =>
      typeof str === 'string'
        ? str
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .trim()
        : '';

    mapData.forEach((item) => {
      const loc = normalize(item.name);
      if (!loc) return;
      if (!grouped[loc]) grouped[loc] = [];
      grouped[loc].push(item);
    });

    const pieSeries: echarts.PieSeriesOption[] = [];

    const values = mapData.map((d) => d.value);
    const minMeasureValue = Math.min(...values);
    const maxMeasureValue = Math.max(...values);
    const geoWidth = Math.min(graphDimension.width, graphDimension.height);
    const centerConfig = geoCenters[geoKey] ?? { center: [0, 0], zoom: 1 };

    const maxRadius = 13;
    const minRadius = 6;

    Object.entries(grouped).forEach(([locName, items]) => {
      const feature = pointFeatures.find((f: any) => {
        const props = f.properties || {};
        return (
          normalize(props.city) === locName ||
          normalize(props.name) === locName ||
          normalize(props[type]) === locName
        );
      });

      if (!feature || !feature.geometry?.coordinates) return;

      const coords = feature.geometry.coordinates;
      const cityMaxVal = Math.max(...items.map((i) => i.value));

      let calculatedRadius =
        ((cityMaxVal - minMeasureValue) / (maxMeasureValue - minMeasureValue || 1)) *
          (maxRadius - minRadius) +
        minRadius;

      pieSeries.push({
        type: 'pie',
        coordinateSystem: 'geo',
        center: coords,
        radius: calculatedRadius,
        z: 2,
        tooltip: {
          show: isTooltipEnabled,
          padding: [-10, -10],

          //splitby for cities map

          formatter: function (params: any) {
            const measureAxis = chartAxes.find((axis: any) => axis.name === 'Measure');
            const dimensionAxis = chartAxes.find((axis: any) => axis.name === 'Location');
            const splitByAxis = chartAxes.find((axis: any) => axis.name === 'Split By');

            const dimensionKey = dimensionAxis?.fields?.[0]?.displayname || 'Location';
            const measureKey = measureAxis?.fields?.[0]?.displayname || 'Value';
            const splitByKey = splitByAxis?.fields?.[0]?.displayname || 'Split By';

            // Parse name for splitBy if present
            let cleanName = params.name;
            let splitValue = '';
            const match = params.name.match(/^(.*?)\s*\((.*?)\)$/);
            if (match) {
              splitValue = match[1].trim();
              cleanName = match[2].trim();
            }

            const d = params.data || {};

            // Base tooltip data
            const tempData: Record<string, string | number> = {
              [dimensionKey]: d.location ?? cleanName,
              [splitByKey]: d.splitBy ?? splitValue,
              [measureKey]: params.value,
            };

            // Filter only checked measures
            const filteredTemp: Record<string, string | number> = {};
            Object.keys(tempData).forEach((key) => {
              if (
                checkUidPresenceInCheckedMeasureForTooltip(
                  chartAxes,
                  key,
                  tooltipFormats?.checkedMeasure,
                ) &&
                tempData[key] !== undefined
              ) {
                filteredTemp[key] = tempData[key];
              }
            });

            let mergedData = { ...filteredTemp };

            const extraResponses = tooltipFormats?.extraMeasureFieldsResponses;
            if (extraResponses?.length) {
              extraResponses.forEach((obj: any) => {
                Object.keys(obj).forEach((key) => {
                  if (!(key in mergedData)) {
                    mergedData[key] = obj[key];
                  }
                });
              });
            }

            const finalFilteredData: Record<string, string | number> = {};
            Object.keys(mergedData).forEach((key) => {
              if (
                checkUidPresenceInCheckedMeasureForTooltip(
                  chartAxes,
                  key,
                  tooltipFormats?.checkedMeasure,
                )
              ) {
                finalFilteredData[key] = mergedData[key];
              }
            });

            return (
              tooltipStyle(
                params.color,
                finalFilteredData,
                tooltipFormats,
                chartAxes,
                measureKey,
              ) || ''
            );
          },
        },
        label: { show: false },
        labelLine: { show: false },
        animationDuration: 0,
        data: items.map((item) => {
          const baseColor = geoStyle.bgCol[item.dim] || '#2bb9bb';

          const fillOpacity = (geoStyle.opacity ?? 70) / 100;
          const fillColor = applyOpacityToColor(baseColor, fillOpacity);

          return {
            value: item.value,
            name: item.dim || 'Other',
            location: item.name,
            splitBy: item.dim,
            key: item.key,

            itemStyle: {
              color: fillColor,
              borderColor: geoStyle.enableBubbleBorder ? baseColor : undefined,
              borderWidth: geoStyle.enableBubbleBorder ? geoStyle.bubbleBorderWidth : 0,
              opacity: 1,
            },
          };
        }),
      });
    });

    return pieSeries;
  };
  // For making an API call for getting bubble size
  let axes: AxesValuProps[] = [];
  axes.push(chartProperties.properties[propKey].chartAxes[0]);
  axes.push(chartProperties.properties[propKey].chartAxes[2]);
  axes.push(chartProperties.properties[propKey].chartAxes[3]);

  axes = JSON.parse(JSON.stringify(axes));

  let res: any;
  const [queryRes, setqueryRes] = useState<any>([]);
  const getBubbleSizeQuery = () => {
    setLoading(true);
    setMapLoading(true);
    getChartData(
      axes,
      chartProperties,
      chartControls,
      chartGroup,
      tabTileProps.tablesForSelectedDataSets,
      dashBoardGroup,
      propKey,
      'Chartaxes',
      token,
      chartProperties.properties[propKey].chartType,
      undefined,
      undefined,
      true,
      savedCalculations,
      undefined,
      chartErrorDetails,
    ).then(async (data) => {
      var url: string = '';
      if (chartProperties.properties[propKey].selectedDs.isFlatFileData) {
        url = `query?datasetid=${chartProperties.properties[propKey].selectedDs.id}`;
      } else {
        url = `query?dbconnectionid=${chartProperties.properties[propKey].selectedDs.connectionId}&datasetid=${chartProperties.properties[propKey].selectedDs.id}&workspaceId=${chartProperties.properties[propKey].selectedDs.workSpaceId}`;
      }
      res = await FetchData({
        requestType: 'withData',
        method: 'POST',
        url: url,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: data,
      });
      setqueryRes(res);
    });
    setLoading(false);
    setMapLoading(false);
  };

  useEffect(() => {
    axes = JSON.parse(JSON.stringify(axes));
    getBubbleSizeQuery();
  }, [
    chartProperties.properties[propKey].chartAxes[3].fields[0],
    chartProperties.properties[propKey].chartAxes[2].fields[0],
    chartProperties.properties[propKey].chartAxes[3]?.fields[0]?.agg,
  ]);
  const setBgColors = () => {
    let mapData = chartData?.map((item) => {
      //const location = item.city || item[keyName]; //
      return {
        //name: item[keyName],
        //name: location,
        name: item[keyName],

        value: item[valueDispName] || 0,
        key: item.city || item[keyName] || item.key,
        dim: !chartData[0].hasOwnProperty(dimName) ? '' : item[dimName],
        // dim: dimName && item.hasOwnProperty(dimName)
        //   ? (item[dimName] === null ? 'null' : item[dimName])
        //   : '',
      };
    });

    // updateGeoChartStyleOptions(propKey, "bgCol", {});
    // geoStyle.bgCol = {};
    // if (!chartProperties.properties[propKey].chartAxes[1].fields.length) {
    // if (Object.keys(mapData).every(item => geoStyle.bgCol?.[item.dim])) {
    const normalize = (str: any) =>
      typeof str === 'string'
        ? str
            .normalize('NFD') // Unicode normalize form
            .replace(/[\u0300-\u036f]/g, '') // remove accents
            .toLowerCase() // lowercase
            .trim() // remove spaces
        : '';

    chartData.forEach((cd) => {
      const location = cd.city || cd[keyName];
      const found = mapData.find((md) => normalize(md.name) === normalize(location));
    });

    if (mapData.every((item) => !geoStyle.bgCol?.[item.dim])) {
      updateGeoChartStyleOptions(propKey, 'bgCol', {});
      geoStyle.bgCol = {};
    }
    index = 0;
    mapData?.forEach((item) => {
      if (item.dim !== undefined && !geoStyle.bgCol?.[item.dim]) {
        if (index < selectedTheme?.colors.length) {
          index++;
          geoStyle.bgCol[item.dim] = selectedTheme?.colors[index - 1];
          // bgColors = JSON.parse(JSON.stringify(bgColors));
          const newBgColors = {
            ...geoStyle.bgCol,
            [item.dim]: selectedTheme?.colors[index - 1],
          };
          updateGeoChartStyleOptions(propKey, 'bgCol', newBgColors);
        } else {
          index = 0;
          index++;
          geoStyle.bgCol[item.dim] = selectedTheme?.colors[index - 1];
          // bgColors = JSON.parse(JSON.stringify(bgColors));
          const newBgColors = {
            ...geoStyle.bgCol,
            // ...geoStyle.bgCol,
            [item.dim]: selectedTheme?.colors[index - 1],
          };
          updateGeoChartStyleOptions(propKey, 'bgCol', newBgColors);
        }
      }
    });
  };
  useEffect(() => {
    setBgColors();
  }, [chartData]);

  // async function registerGeoMap(name: string) {
  //   //https://code.highcharts.com/mapdata/
  //   //https://github.com/adarshbiradar/maps-geojson/tree/master/states
  //   var ROOT_PATH = 'https://echarts.apache.org/examples';

  //   // setLoading(true);
  //   // setMapLoading(true);
  //   let geoJSON = await getGeoJSON(name, setLoading);
  //   setMapJSON(geoJSON); //for MapJSON used at other places like chartAxes
  //   setMapGeoJSON(geoJSON); // for MapJSON used here
  //   setLoading(false);
  //   // setMapLoading(false);
  // }

  const [cityJSON, setCityJSON] = useState<any>(null);

  async function registerGeoMap(name: string) {
    const geoJSON = await getGeoJSON(name, setLoading);

    if (geoJSON.base && geoJSON.cities) {
      // setMapJSON(...geoJSON.base,...geoJSON.cities);
      setMapJSON({
        type: 'FeatureCollection',
        features: [
          ...geoJSON.base?.features, // base polygon features (states or whole country)
          ...geoJSON.cities?.features, // city point features
        ],
      });
      setCityJSON(geoJSON.cities);
      setMapGeoJSON(geoJSON.base);
      setLoading(false);
      return;
    }

    // normal map
    setMapJSON(geoJSON);
    setMapGeoJSON(geoJSON);
    setCityJSON(null);
    setLoading(false);
  }

  useEffect(() => {
    if (mapJSON?.features)
      echarts.registerMap(chartProperties.properties[propKey].Geo.geoLocation, mapJSON, {});
  }, [mapJSON, chartProperties.properties[propKey].Geo.geoLocation]);

  const normalizeName = (raw: any): string[] => {
    if (Array.isArray(raw)) {
      return raw.map((v) => String(v ?? '').trim()).filter(Boolean);
    }

    const value = String(raw ?? '').trim();
    return value ? [value] : [];
  };

  useEffect(() => {
    (async () => {
      await registerGeoMap(chartProperties.properties[propKey].Geo.geoLocation);
    })();
  }, [chartProperties.properties[propKey].Geo.geoLocation]); //new map

  const convertIntoMapData = () => {
    // bubbleSize = queryRes?.data?.map((item: any) => {
    //   return {
    //     name: item[keyName],
    //     value: item[valueDispName],
    //   };
    // });
    bubbleSize = Array.isArray(queryRes?.data)
      ? queryRes.data.map((item: any) => ({
          name: item[keyName],
          value: item[valueName], // Using valueName as result is a query response and not chartData
        }))
      : [];

    if (chartData && chartData.length > 0) {
      let keyNameArray: string[] = [];
      let matchingMapJSONArray: any = [];

      // chartData?.map((item) => {
      //   keyNameArray.push(item[keyName]?.toString().trim());
      // });
      chartData.forEach((item) => {
        keyNameArray.push(...normalizeName(item?.[keyName]));
      });

      // mapJSON.features.forEach((item: any) => {
      //   if (keyNameArray.includes(item.properties[type])) {
      //     matchingMapJSONArray.push({
      //       key: item.properties[type],
      //       name: item.properties['name'],
      //     });
      //   }
      // });
      const features = Array.isArray(mapJSON?.features) ? mapJSON.features : [];

      features.forEach((item: any) => {
        const key = item?.properties?.[type];
        const name = item?.properties?.name;

        if (!key) return;

        if (keyNameArray.includes(String(key))) {
          matchingMapJSONArray.push({
            key,
            name,
          });
        }
      });

      if (dimName && chartData.length) {
        chartData = chartData.map((row) => {
          if (!(dimName in row)) {
            return {
              ...row,
              [dimName]:
                chartProperties.properties[propKey].chartAxes[1]?.fields?.[0]?.fieldname || '', // fallback from another field
            };
          }
          return row;
        });
      }

      const hasNullValues = chartData.some((item) => item.hasOwnProperty(dimName));
      // const hasNullValues = chartData.some(
      //   (item) => dimName && (item[dimName] === null || item[dimName] === undefined)
      // );

      mapData = chartData?.map((item) => {
        return {
          // name: matchingMapJSONArray.find((match: any) => match.key === item[keyName]?.trim()),
          // //   ?.name,
          name:
            matchingMapJSONArray.find((match: any) => match.key === item[keyName]?.trim())?.name ||
            (geoKey.includes('Cities') && item[keyName]),

          //name: item[keyName],&
          value: item[valueDispName] || 0,
          key: item[keyName],
          // dim: item[dimName]
          //   ? item[dimName]
          //   : item[dimName] === null
          //   ? "null"
          //   : "",
          dim: !hasNullValues ? '' : item[dimName] === null ? 'null' : item[dimName],
          // dim: dimName
          //   ? (item[dimName] === null ? 'null' : item[dimName])
          //   : '',

          // dim: !chartData[0].hasOwnProperty(dimName) ? "" : item[dimName],
          size: bubbleSize?.find((match: any) => match.name === String(item[keyName] || '')?.trim())
            ?.value,
        };
      });

      // setBgColors();

      if (chartProperties.properties[propKey].Geo.unMatchedChartData?.length > 0) {
        chartProperties.properties[propKey].Geo.unMatchedChartData.forEach((item: any) => {
          if (item.selectedKey != '') {
            // Find all occurrences of the key in mapData
            const matchingDataItems = mapData.filter(
              (dataItem) => String(dataItem.key) === String(item[keyName]),
            );

            // Update each matching data item
            matchingDataItems.forEach((data) => {
              const name = item.selectedKey.includes(';')
                ? item.selectedKey.split(';')[1]?.trim()
                : item.selectedKey;
              data.name = name;
            });
          }
        });
      }

      // const visibleCities = mapData.filter((item) => item?.name).map((item) => item.name.trim());
      const visibleCities = mapData.flatMap((item) => normalizeName(item?.name));

      let uniqueCities = Array.from(new Set(visibleCities));
    }
  };

  const calculateDataRange = (data: any[], column: string) => {
    if (!column || !data || data.length === 0 || (data[0] && !(column in data[0]))) {
      return { min: 0, max: 100 };
    }

    const valuesArray = data.map((el: any) => Number(el[column]) || 0);
    let minValue = Math.min(...valuesArray);
    let maxValue = Math.max(...valuesArray);

    //  Prevent slider collapse if all values are equal
    if (minValue === maxValue) {
      if (maxValue === 0) {
        maxValue = 100;
      } else {
        minValue = 0;
      }
    }

    return { min: minValue, max: maxValue };
  };

  const calculatedLimits = useMemo(() => {
    return calculateDataRange(chartData, valueDispName);
  }, [chartData, valueDispName]);

  const hasMeasureChanged = prevValueNameRef.current !== valueDispName;

  const activeMinValue = hasMeasureChanged
    ? calculatedLimits.min
    : geoStyle.minValue !== '' && geoStyle.minValue !== null
      ? Number(geoStyle.minValue)
      : calculatedLimits.min;

  const activeMaxValue = hasMeasureChanged
    ? calculatedLimits.max
    : geoStyle.maxValue !== '' && geoStyle.maxValue !== null
      ? Number(geoStyle.maxValue)
      : calculatedLimits.max;

  const isInverted = activeMinValue > activeMaxValue;
  const visualMin = isInverted ? activeMaxValue : activeMinValue;
  const visualMax = isInverted ? activeMinValue : activeMaxValue;

  useEffect(() => {
    if (chartData.length > 0 && valueDispName) {
      if (prevValueNameRef.current !== valueDispName) {
        if (chartData[0] && valueDispName in chartData[0]) {
          dispatch(
            updateGeoChartStyleOptions(propKey, 'minValue', calculatedLimits.min.toFixed(2)),
          );
          dispatch(
            updateGeoChartStyleOptions(propKey, 'maxValue', calculatedLimits.max.toFixed(2)),
          );
          prevValueNameRef.current = valueDispName;
        }
      }
    }
  }, [valueDispName, chartData, propKey, dispatch, calculatedLimits]);

  function resolveCenterFromGeo(name: string | number[]) {
    if (typeof name !== 'string') {
      return name;
    }
    // const feature = mapJSON.features.find((f: any) => f.properties.name === name);

    const feature = mapJSON?.features?.find((f: any) => {
      const props = f.properties || {};
      return props.name === name || props[geoMapKey] === name;
    });

    if (feature) {
      if (feature.properties.longitude && feature.properties.latitude) {
        return [parseFloat(feature.properties.longitude), parseFloat(feature.properties.latitude)];
      }
      // Return the centroid of the polygon
      const coords = feature.geometry.coordinates;
      let centerCoord;

      if (feature.geometry.type === 'Polygon') {
        centerCoord = getPolygonCenter(coords[0]);
      } else if (feature.geometry.type === 'MultiPolygon') {
        centerCoord = getPolygonCenter(coords[0][0]);
      }
      return centerCoord;
    }
    return [0, 0];
  }

  function getPolygonCenter(polygon: [number, number][]) {
    let [sumX, sumY] = [0, 0];
    polygon.forEach(([x, y]) => {
      sumX += x;
      sumY += y;
    });
    return [sumX / polygon.length, sumY / polygon.length];
  }

  function renderBubble(center: string | number[], radius: number): echarts.PieSeriesOption {
    // Calculate Min/Max for Gradient logic
    const allValues = mapData.map((d) => d.value);
    const dataMin = Math.min(...allValues);
    const dataMax = Math.max(...allValues);

    // Use shared gradient configuration
    const { endColor, gradientColors } = getGradientConfig();

    const seriesColors = chartProperties.properties[propKey].chartAxes[1].fields[0]
      ? geoStyle.bgCol
      : gradientColors;

    let data = [];

    const normalize = (str: any) =>
      typeof str === 'string'
        ? str
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .trim()
            .toLowerCase()
        : '';

    data = mapData.map((dataItem) => {
      if (
        (dataItem.name && dataItem.name === center) ||
        (dataItem.key && dataItem.key === center)
      ) {
        // Use shared helper for bubble color calculation
        const baseColor = getBubbleColor(
          dataItem.value,
          dataItem.dim,
          dataMin,
          dataMax,
          gradientColors,
          endColor,
        );

        const fillOpacity = (geoStyle.opacity ?? 70) / 100;
        const fillColor = applyOpacityToColor(baseColor, fillOpacity);

        return {
          value: dataItem.value,
          name:
            keyName +
            ' : ' +
            dataItem.key +
            ', ' +
            (dimDispName
              ? dimDispName + ' : ' + (dataItem.dim !== undefined ? dataItem.dim : '') + ', '
              : '') +
            valueDispName +
            ' ',

          itemStyle: {
            color: fillColor,
            borderColor: geoStyle.enableBubbleBorder ? baseColor : undefined,
            borderWidth: geoStyle.enableBubbleBorder ? geoStyle.bubbleBorderWidth : 0,
            opacity: 1,
          },
        };
      }
    });

    const filteredData = data.filter((item) => item !== undefined);

    return {
      type: 'pie',
      coordinateSystem: 'geo',

      color: seriesColors,

      tooltip: {
        show: isTooltipEnabled,
        trigger: 'item',
        backgroundColor: 'white',
        borderWidth: 1,
        padding: 0,
        textStyle: {
          color: '#333',
          fontSize: 16,
        },
        confine: true,
        extraCssText:
          'box-shadow: 0 2px 8px rgba(0,0,0,0.15);white-space: normal; word-break: break-word;z-index:1000',
        formatter: function (params: any) {
          const bubbleData = params.data;
          const splittedBubbleData = bubbleData.name.split(',');

          const firstPair = splittedBubbleData[0].split(':');
          const secondPair = splittedBubbleData[1]?.split(':');

          const firstFieldName = firstPair[0].trim();
          const firstFieldValue = firstPair[1].trim();
          const secondFieldName = secondPair?.[0]?.trim();

          const tempData: { [key: string]: string | number } = {};
          tempData[firstFieldName] = firstFieldValue;

          let secondFieldValue: any;
          const isNoSplitBy = splittedBubbleData.length === 2;

          if (isNoSplitBy) {
            secondFieldValue = bubbleData.value;
          } else {
            secondFieldValue = secondPair[1].trim();
            const possibleMeasureName = splittedBubbleData[2].trim();

            tempData[secondFieldName] = secondFieldValue;
          }

          let percent: string = ' ';

          const _data: { [key: string]: string | number } = {};

          _data[firstFieldName] = tempData[firstFieldName];

          Object.keys(tempData).forEach((key: string) => {
            if (key === firstFieldName) return; // skip first dimension

            const isChecked = checkUidPresenceInCheckedMeasureForTooltip(
              chartAxes,
              key,
              tooltipFormats?.checkedMeasure,
            );

            if (isChecked) {
              _data[key] = tempData[key];
            }
          });

          const measureAxis = chartAxes.find((axis: any) => axis.name === 'Measure');
          const measureKey = measureAxis?.fields[0]?.displayname;

          const isMeasureChecked = checkUidPresenceInCheckedMeasureForTooltip(
            chartAxes,
            measureKey,
            tooltipFormats?.checkedMeasure,
          );

          if (isMeasureChecked) {
            _data[measureKey] = bubbleData.value;
          }

          let mergedData = { ..._data };

          const extraResponses = tooltipFormats.extraMeasureFieldsResponses;

          if (tooltipFormats && extraResponses.length > 0) {
            let extraFieldObj;

            if (isNoSplitBy) {
              extraFieldObj = extraResponses.find(
                (obj: any) => String(obj[firstFieldName]) === String(firstFieldValue),
              );

              if (extraFieldObj) {
                const {
                  [firstFieldName]: v1,
                  [secondFieldName]: v2,
                  ...restExtraFields
                } = extraFieldObj;

                const filteredExtraFields = { ...restExtraFields };
                if (!isMeasureChecked) {
                  delete filteredExtraFields[measureKey];
                }

                mergedData = { ...mergedData, ...filteredExtraFields };
              }
            } else {
              extraFieldObj = extraResponses.find(
                (obj: any) =>
                  String(obj[firstFieldName]) === String(firstFieldValue) &&
                  String(obj[secondFieldName]) === String(secondFieldValue),
              );

              if (extraFieldObj) {
                const {
                  [firstFieldName]: v1,
                  [secondFieldName]: v2,
                  ...restExtraFields
                } = extraFieldObj;

                const filteredExtraFields = { ...restExtraFields };
                if (!isMeasureChecked) {
                  delete filteredExtraFields[measureKey];
                }

                mergedData = { ...mergedData, ...filteredExtraFields };
              }
            }
          }

          const misMatchedDataInRedux =
            chartProperties.properties[propKey]?.Geo?.unMatchedChartData;

          let tempMergedData = { ...mergedData };

          if (misMatchedDataInRedux) {
            for (let data of misMatchedDataInRedux) {
              if (String(data[firstFieldName]) === String(tempMergedData[firstFieldName])) {
              }
            }
            mergedData = { ...tempMergedData };
          }

          return tooltipStyle(
            params.color,
            mergedData,
            tooltipFormats,
            chartAxes,
            firstFieldName,
            measureKey,
            percent,
            fontFamily,
          );
        },
      },
      label: {
        show: false,
      },
      labelLine: {
        show: false,
      },
      animationDuration: 0,
      radius,
      center: resolveCenterFromGeo(center),
      data: filteredData,
    };
  }
  const geoKey = chartProperties.properties[propKey].Geo.geoLocation;
  const isCityMap = geoKey.includes('Cities');
  const geoMapKey = chartProperties.properties[propKey].Geo.geoMapKey;

  useEffect(() => {
    //  let mapMinMax: any = getMinAndMaxValue(valueDispName);
    convertIntoMapData();

    let dataMax = 100;
    let dataMin = 0;

    if (bubbleSize && bubbleSize.length > 0) {
      const validValues = bubbleSize
        .map((obj) => obj?.value)
        .filter((v) => v !== undefined && v !== null);

      if (validValues.length > 0) {
        dataMax = Math.max(...validValues);
        dataMin = Math.min(...validValues);
      }
    }

    // Effective Range (User Input > Data Actual)
    // If user has typed a value in the properties panel, use that. Otherwise use data actuals.
    const userMin = parseFloat(geoStyle.minValue);
    const userMax = parseFloat(geoStyle.maxValue);

    const effectiveMin = !isNaN(userMin) ? userMin : dataMin;
    const effectiveMax = !isNaN(userMax) ? userMax : dataMax;

    // Bubble Series with Clamping
    const series = mapData.map((dataItem) => {
      let rawValue = dataItem.value;

      // Use bubbleSize override if available
      bubbleSize?.forEach((item) => {
        if (dataItem.key === item.name) {
          rawValue = item.value;
        }
      });

      // CLAMP THE VALUE:
      // If value is below min, force it to min (so it gets minBubbleSize)
      // If value is above max, force it to max (so it gets maxBubbleSize)
      let clampedValue = rawValue;
      if (clampedValue < effectiveMin) clampedValue = effectiveMin;
      if (clampedValue > effectiveMax) clampedValue = effectiveMax;

      // Calculate sizes
      let geoWidth = Math.min(graphDimension.width, graphDimension.height);
      const centerZoom = geoCenters[geoKey]?.zoom ?? 1; // Fallback to 1
      const zoomFactor = geoStyle.mapZoom * (isCityMap ? centerZoom : 1);

      const maxBubblePx = ((geoWidth * zoomFactor) / 10) * (geoStyle.maxBubbleSize / 100);
      const minBubblePx = ((geoWidth * zoomFactor) / 10) * (geoStyle.minBubbleSize / 100);

      // Calculate Radius
      let radius =
        ((clampedValue - effectiveMin) / (effectiveMax - effectiveMin || 1)) *
          (maxBubblePx - minBubblePx) +
        minBubblePx;

      // Safety Cap (Max 1/15th of map width)
      const radiusCap = (geoWidth * zoomFactor) / 15;
      if (radius > radiusCap) radius = radiusCap;

      if (dataItem.name) return renderBubble(dataItem.name, radius);
    });
    const hexRemovehelperMap = (color: any) => {
      if (typeof color === 'string' && color.startsWith('#') && color.length === 9) {
        return color.slice(0, 7);
      }
      return color;
    };

    const mapStartRaw =
      geoStyle.manualColor && geoStyle.minColor && geoStyle.minColor !== ''
        ? geoStyle.minColor
        : selectedTheme?.colors?.[1] || '#85c1e9';

    const mapEndRaw =
      geoStyle.manualColor && geoStyle.maxColor && geoStyle.maxColor !== ''
        ? geoStyle.maxColor
        : selectedTheme?.colors?.[0] || '#2e86c1';

    const mapStartColor = hexRemovehelperMap(mapStartRaw);
    const mapEndColor = hexRemovehelperMap(mapEndRaw);
    let inRange;

    if (!chartProperties.properties[propKey]?.chartAxes?.[1]?.fields?.[0]) {
      if (geoStyle.manualColor) {
        const start = isInverted ? mapEndColor : mapStartColor;
        const end = isInverted ? mapStartColor : mapEndColor;
        inRange = {
          color: interpolateColor(start, end, 20),
        };
      } else if (selectedTheme?.colors?.length >= 2) {
        const c1 = selectedTheme.colors[1];
        const c0 = selectedTheme.colors[0];
        const start = isInverted ? c0 : c1;
        const end = isInverted ? c1 : c0;

        inRange = {
          color: interpolateColor(start, end, 20),
        };
      } else {
        inRange = { color: ['#ccc'] }; // fallback color array
      }
    } else {
      inRange = { color: '#969494ff' };
    }

    const scatterData = generateScatterData();

    const stateNameList: string[] = [];

    // if (!mapJSON?.features?.length) {
    //   console.warn('⚠️ Map JSON not loaded or invalid for this geoLocation');
    //   return;
    // }
    const features = Array.isArray(mapJSON?.features) ? mapJSON.features : [];

    scatterData.forEach((city) => {
      const [lon, lat] = city.value || [];
      if (lon == null || lat == null) return;

      const point = turf.point([lon, lat]);
      let matchedState: string | null = null;

      for (const feature of features) {
        // const { geometry, properties } = feature;
        // if (!geometry || !['Polygon', 'MultiPolygon'].includes(geometry.type)) continue;

        const geometry = feature?.geometry;
        if (
          !geometry ||
          (geometry.type !== 'Polygon' && geometry.type !== 'MultiPolygon') ||
          !Array.isArray(geometry.coordinates) ||
          geometry.coordinates.length === 0
        ) {
          continue;
        }

        try {
          if (turf.booleanPointInPolygon(point, feature.geometry)) {
            // matchedState = properties?.name;
            matchedState = feature?.properties?.name ?? null;
            break;
          }
        } catch (err) {
          console.error(`Polygon check failed`, err);
        }
      }

      if (matchedState) stateNameList.push(matchedState);
    });

    const uniqueStateList = [...new Set(stateNameList)];

    // const stateNames = mapData.filter((item) => item?.name).map((item) => item.name.trim());
    const stateNames = mapData.flatMap((item) => normalizeName(item?.name));

    let useDivergent =
      (chartControls.properties[propKey]?.geoChartControls?.isDivergentModeEnabled ||
        geoStyle.manualColor) ??
      false;

    useDivergent =
      useDivergent && Array.isArray(_dimensionField?.fields) && _dimensionField.fields.length === 0;

    const separator = geoStyle.isDivergentFormat || 'None';
    const formatType = geoStyle.divergentFormatValue || 'Number';
    const enableRounding = geoStyle.enableRounding ?? true;
    const roundingDigits = geoStyle.roundingDigits ?? 1;
    const currencySymbol = geoStyle.currencySymbol ?? '$';
    const resolvedTextColor = chartControl.labelOptions.labelColor
      ? chartControl.labelOptions.labelColor
      : selectedTheme?.dark
        ? '#ffffff'
        : '#757474';

    const visualMapConfig = useDivergent
      ? {
          left: 'right',
          min: visualMin,
          max: visualMax,
          inRange,
          ...(selectedRangeRef.current ? { range: selectedRangeRef.current } : {}),
          calculable: true,
          itemHeight: graphDimension.height / 3.3,
          text: ['Max', 'Min'],
          textStyle: {
            color: resolvedTextColor,
          },
          show:
            Math.floor(graphDimension.height) > LEGEND_THRESHOLDS.common.h &&
            Math.floor(graphDimension.width) > LEGEND_THRESHOLDS.common.w &&
            chartData.length > 0
              ? geoStyle.showVisualScale
              : false,

          formatter: (value: number) =>
            formatMinMaxValue(value, separator, formatType, enableRounding, roundingDigits),
        }
      : {
          inRange: {
            color: [selectedTheme?.colors[0] || '#2bb9bb'],
          },
          show: false,
        };
    // undefined;

    if (
      mapJSON.features &&
      chartProperties.properties[propKey].Geo.unMatchedChartData &&
      echarts.getMap(chartProperties.properties[propKey].Geo.geoLocation)
    )
      setOptions({
        geo: {
          map: chartProperties.properties[propKey].Geo.geoLocation,
          silent: false,
          show: true,
          aspectScale: geoStyle.aspectScale * (aspectScaleMap[geoKey] || 1),
          // ...narrowMapOverrides[chartProperties.properties[propKey].Geo.geoLocation],

          emphasis: {
            focus: geoStyle.enableSelfEmphasis ? 'self' : 'normal',
          },
          select: {
            disabled: true,
          },

          label: {
            normal: {
              show:
                Math.floor(graphDimension.height) > LABEL_THRESHOLDS.common.h
                  ? chartControl.labelOptions.showLabel
                  : false,
              formatter: (params: any) => {
                if (stateCheckBox) {
                  const displayList = uniqueStateList.length > 0 ? uniqueStateList : stateNames;

                  return displayList.includes(params.name) ? params.name : '';
                }
                return params.name;
              },

              textStyle: {
                color: chartControl.labelOptions.labelColor
                  ? chartControl.labelOptions.labelColor
                  : selectedTheme?.dark
                    ? palette.secondary.contrastText
                    : palette.primary.contrastText,
                backgroundColor: chartControl.labelOptions.labelBackground
                  ? chartControl.labelOptions.labelBackgroundColor
                  : 'transparent',
                borderRadius: chartControl.labelOptions.labelBackground ? 4 : 0,
                padding: chartControl.labelOptions.labelBackground ? [4, 8] : 0,
                fontSize: chartControl.labelOptions.fontSize - 4,
                fontFamily: fontFamily,
              },
            },
            emphasis: {
              show:
                Math.floor(graphDimension.height) > LABEL_THRESHOLDS.common.h
                  ? chartControl.labelOptions.showLabel
                  : false,
              textStyle: {
                color: chartControl.labelOptions.labelColor
                  ? chartControl.labelOptions.labelColor
                  : null,
                // backgroundColor: geoStyle.emphasisAreaColor,
                fontSize: chartControl.labelOptions.fontSize - 4,
                fontFamily: fontFamily,
              },
            },
          },

          // roam: true,
          //zoom: geoStyle.mapZoom,
          center: isCityMap ? geoCenters[geoKey]?.center : undefined,
          // zoom: isCityMap ? geoCenters[geoKey]?.zoom : geoStyle.mapZoom,
          zoom: geoStyle.mapZoom * (isCityMap ? (geoCenters[geoKey]?.zoom ?? 1.1) : 1.1),

          itemStyle: {
            normal: {
              areaColor: geoStyle.manualColor
                ? geoStyle.areaColor
                : selectedTheme?.tableHeaderBackground,
              borderColor: geoStyle.manualColor
                ? geoStyle.borderColor
                : selectedTheme?.dark
                  ? palette.secondary.contrastText
                  : 'grey',
              borderWidth: geoStyle.boderWidth,
            },
            emphasis: {
              // areaColor: geoLocation.includes('Cities')
              //   ? geoStyle.manualColor
              //     ? geoStyle.areaColor
              //     : selectedTheme?.tableHeaderBackground
              //   : geoStyle.emphasisAreaColor,
              areaColor: geoStyle.emphasisAreaColor,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: geoLocation.includes('Cities') ? 0 : 20,
              shadowColor: geoLocation.includes('Cities') ? 'transparent' : 'rgba(0, 0, 0, 0.5)',
              borderColor: geoStyle.manualColor,
              borderWidth: geoLocation.includes('Cities') ? geoStyle.boderWidth : 0,
            },
          },
          zlevel: 0,
        },
        /* null / {}	*/
        backgroundColor: selectedTheme?.background,
        tooltip: chartControls.properties[propKey].mouseOver.enable
          ? {
              trigger: 'item',
              showDelay: 0,
              transitionDuration: 0.2,
            }
          : null,

        visualMap: visualMapConfig,

        series: [
          ...(geoKey.includes('Cities') &&
          chartProperties.properties[propKey].chartAxes[1]?.fields?.length > 0
            ? generatePieSeriesForCities()
            : []),

          ...(geoKey.includes('Cities') ? [] : series),

          ...(geoKey.includes('Cities') &&
          chartProperties.properties[propKey].chartAxes[1]?.fields?.length === 0 &&
          scatterData.length >= 0
            ? [
                {
                  name: 'City Scatter',
                  type: 'scatter',
                  coordinateSystem: 'geo',
                  geoIndex: 0,
                  data: scatterData,
                  // data:
                  //   cityJSON?.features?.map((f: any) => ({
                  //     name: f.properties?.name,
                  //     value: f.geometry?.coordinates,
                  //   })) ?? [],
                  symbolSize: function (val: any) {
                    const value = val[2];
                    // const minSize =
                    // const maxSize = 25;
                    let geoWidth = Math.min(graphDimension.width, graphDimension.height);
                    const centerZoom = geoCenters[geoKey]?.zoom ?? 1; // Fallback to 1
                    const zoomFactor = geoStyle.mapZoom * (isCityMap ? centerZoom : 1);
                    const maxBubbleSizes =
                      (((geoWidth * zoomFactor) / 10) * geoStyle.maxBubbleSize) / 100;
                    const minBubbleSizes =
                      (((geoWidth * zoomFactor) / 10) * geoStyle.minBubbleSize) / 100;
                    const values = scatterData.map((d) => d.value[2]);
                    const minValue = Math.min(...values);
                    const maxValue = Math.max(...values);
                    const normalized = (value - minValue) / (maxValue - minValue || 1);
                    const finalSize =
                      maxBubbleSizes + normalized * (maxBubbleSizes - minBubbleSizes);

                    // Explicit NaN Check
                    if (isNaN(finalSize)) return 10;

                    return Math.max(finalSize, 5);
                  },

                  label: {
                    show: showStateLabel,
                    formatter: '{b}',
                    position: 'top',
                    opacity: 0.9,
                    color: chartControl.labelOptions.labelColor
                      ? chartControl.labelOptions.labelColor
                      : null,
                    backgroundColor: chartControl.labelOptions.labelBackground
                      ? chartControl.labelOptions.labelBackgroundColor
                      : 'transparent',
                    borderRadius: chartControl.labelOptions.labelBackground ? 4 : 0,
                    padding: chartControl.labelOptions.labelBackground ? [4, 8] : 0,
                  },
                  tooltip: {
                    show: isTooltipEnabled,

                    formatter: function (params: any) {
                      // cities map formatter
                      const measureAxis = chartAxes.find((axis: any) => axis.name === 'Measure');
                      const measureKey = measureAxis?.fields?.[0]?.displayname || 'Value';

                      const locationAxis = chartAxes.find((axis: any) => axis.name === 'Location');
                      const locationField = locationAxis?.fields?.[0]?.displayname || 'Location';

                      const droppedLocation =
                        params.data?.originalLocation ?? params.data?.originalKey;

                      const measureValue =
                        Array.isArray(params.value) && params.value.length > 2
                          ? params.value[2]
                          : params.value;

                      const tempData: Record<string, string | number> = {
                        [locationField]: droppedLocation,
                        [measureKey]: measureValue as number,
                      };

                      const _data: Record<string, string | number> = {};

                      Object.keys(tempData).forEach((key: string) => {
                        const resp = checkUidPresenceInCheckedMeasureForTooltip(
                          chartAxes,
                          key,
                          tooltipFormats?.checkedMeasure,
                        );

                        if (resp && tempData[key] !== undefined) {
                          _data[key] = tempData[key];
                        }
                      });

                      let mergedData = { ..._data };

                      const extraResponses = tooltipFormats?.extraMeasureFieldsResponses;

                      if (extraResponses?.length) {
                        const extraFieldObj = extraResponses.find(
                          (obj: any) =>
                            String(obj?.[locationField as keyof typeof obj]) ===
                            String(droppedLocation),
                        );

                        if (extraFieldObj) {
                          const { [locationField]: v1, ...restExtraFields } = extraFieldObj;
                          mergedData = { ...mergedData, ...restExtraFields };
                        }
                      }

                      const finalFilteredData: Record<string, string | number> = {};

                      Object.keys(mergedData).forEach((key) => {
                        const resp = checkUidPresenceInCheckedMeasureForTooltip(
                          chartAxes,
                          key,
                          tooltipFormats?.checkedMeasure,
                        );

                        if (resp) {
                          finalFilteredData[key] = mergedData[key];
                        }
                      });

                      return tooltipStyle(
                        params.color,
                        finalFilteredData,
                        tooltipFormats,
                        chartAxes,
                        measureKey,
                      );
                    },
                    textStyle: {
                      fontSize: 12,
                    },
                    padding: [-10, -10],
                  },
                  zlevel: 4,

                  emphasis: {
                    scale: true,
                    focus: 'self',
                    itemStyle: { opacity: 1 },
                  },
                  blur: {
                    itemStyle: { opacity: 0.5 },
                  },

                  hoverAnimation: false,
                  animationDuration: 0,
                },
              ]
            : []),
        ],
      });
  }, [
    chartControl,
    chartProperties.properties[propKey].Geo,
    type,
    // bgColors,
    geoStyle,
    graphDimension,
    // geoStyle.bgColor,
    chartData,
    queryRes,
    mapJSON,
    cityGeoJSON,
    chartProperties.properties[propKey].Geo.unMatchedChartData,
    activeMinValue,
    activeMaxValue,
    valueDispName,
  ]);
  const [hoveredColumns, setHoveredColumns] = useState<Record<string, any>[]>([]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!mouseOverInteractivity) return;
      const hoveredItems = tabState.tabs[selectedTab].hoveredItems;
      const chartInstance = chartRef.current?.getEchartsInstance?.();

      if (!chartInstance || chartInstance.isDisposed?.()) return;

      if (!hoveredItems?.length) {
        chartInstance.dispatchAction({ type: 'downplay' });
        return;
      }

      const option = chartInstance.getOption();
      const seriesList = option.series || [];

      seriesList.forEach((series: any, sIndex: number) => {
        (series.data || []).forEach((dataItems: any, dIndex: number) => {
          let matchCount = 0;

          convertNameToObjectsArray(dataItems.name).forEach((dataItem: any) => {
            hoveredItems.forEach((hovered: Record<string, any>) => {
              for (const key of chartDataKeys) {
                if (
                  hovered[key] &&
                  dataItem[key] &&
                  String(hovered[key]) === String(dataItem[key])
                ) {
                  matchCount++;
                }
              }
            });
          });

          if (matchCount === hoveredItems.length) {
            chartInstance.dispatchAction({
              type: 'highlight',
              seriesIndex: sIndex,
              dataIndex: dIndex,
            });
          } else {
            chartInstance.dispatchAction({
              type: 'downplay',
              seriesIndex: sIndex,
              dataIndex: dIndex,
            });
          }
        });
      });
    }, 30);

    return () => clearTimeout(timeout);
  }, [tabState.tabs[selectedTab].hoveredItems, chartData, chartDataKeys]);

  const hoveredRef = useRef<Record<string, any> | null>(null);
  const convertNameToObjectsArray = (input: string): Array<Record<string, string | number>> => {
    return input
      .split(',')
      .map((part) => part.trim())
      .filter((part) => part.includes(':'))
      .map((part) => {
        const [rawKey, rawValue] = part.split(':');
        const key = rawKey.trim();
        const value = rawValue.trim();

        const parsedValue = /^\d+$/.test(value) ? Number(value) : value;
        return { [key]: parsedValue };
      });
  };

  useEffect(() => {
    selectedRangeRef.current = null; // Reset the selected range
  }, [chartData]);
  const hoverdTimeout = useRef<NodeJS.Timeout | null>(null);

  const handleChartReady = (chartInstance: any) => {
    if (!mouseOverInteractivity) return;

    chartRef.current = chartInstance;

    chartInstance.on('datarangeselected', (e: any) => {
      if (e.selected) {
        selectedRangeRef.current = e.selected as [number, number];
      }
    });

    chartInstance.on('mouseover', (params: any) => {
      if (params.name) {
        const parsedArray = convertNameToObjectsArray(params.name);
        const currentVal = parsedArray[0]?.[chartDataKeys[0]];
        const lastVal = hoveredRef.current?.[0]?.[chartDataKeys[0]];

        if (currentVal !== lastVal) {
          if (hoverdTimeout.current) clearTimeout(hoverdTimeout.current);
          hoverdTimeout.current = setTimeout(() => {
            hoveredRef.current = parsedArray;
            setHoveredColumns(parsedArray);
          }, 200);
        }
      }
    });

    chartInstance.on('mouseout', (params: any) => {
      if (hoverdTimeout.current) clearTimeout(hoverdTimeout.current);
      if (params?.seriesName || params?.componentType === 'series') {
        hoveredRef.current = null;
        setHoveredColumns([]);
      }
    });
  };

  useEffect(() => {
    dispatch(updateHoveredItems(selectedTab, hoveredColumns, propKey));
  }, [hoveredColumns]);

  const RenderChart = () => {
    return (
      <>
        {mapLoading ? <LoadingPopover /> : null}
        <ReactEcharts
          ref={chartRef}
          onChartReady={handleChartReady}
          option={options}
          style={{ width: graphDimension.width, height: graphDimension.height }}
        />
      </>
    );
  };

  return <RenderChart />;
};

const mapStateToProps = (state: ChartsMapStateToProps & any, ownProps: any) => {
  return {
    chartControls: state.chartControls,
    chartProperties: state.chartProperties,
    chartGroup: state.chartFilterGroup,
    token: state.isLogged.accessToken,
    dashBoardGroup: state.dashBoardFilterGroup,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    updateGeoChartStyleOptions: (propKey: string, option: string, value: any) =>
      dispatch(updateGeoChartStyleOptions(propKey, option, value)),
    changeGeoMapUnMatched: (propKey: string, value: any) =>
      dispatch(changeGeoMapUnMatched(propKey, value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BubbleMap);
